<template>
  <div class="lidaCard">
    <div class="tc mb-4"><h3>{{$route.meta.title}}</h3></div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "setting"
};
</script>
